// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"99d3077f","358":"bffbd517","406":"cc31557e","420":"9e8b7759","958":"7afe6b1a"}[chunkId] + ".chunk.js";
};